import { createStructuredSelector } from 'reselect';
import core, { App, View } from '@gin-betting/core';

import { State } from 'types';
import ui from 'modules/ui';
import { usePureSelector } from 'hooks';
import { selectRouteBySportEvent } from 'selectors';

const {
    entities: {
        selectors: { selectMatch, selectMatchCompetitorsValid },
    },
} = core;

const {
    selectors: { selectOddsStatisticView },
} = ui;

interface Input {
    matchId: string;
}

interface Output {
    match: View.Match | null;
    competitors: View.CompetitorsValid;
    linkToMatch: string | null;
    isOddStatVisible: boolean;
}

const selectProps = createStructuredSelector({
    match: selectMatch,
    competitors: selectMatchCompetitorsValid,
    route: selectRouteBySportEvent,
    oddStatView: selectOddsStatisticView,
});

const useMatchRow = ({ matchId }: Input): Output => {
    const {
        match,
        competitors,
        route,
        oddStatView,
    } = usePureSelector((state: State) => selectProps(state, { matchId }));

    const linkToMatch = match
        ? `${route}${App.Routes.MATCH}${match.slug}`
        : null;

    return {
        match,
        competitors,
        linkToMatch,
        isOddStatVisible: oddStatView.show,
    };
};

export default useMatchRow;
